import { createTheme } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { wbTheme } from '@workbuzz/shared-ui';

import {
  MuiCssBaselineStyles,
  MuiMenuItemStyles,
  MuiOutlinedInputStyles,
  MuiTooltipStyles,
} from './MuiComponentStyles/index';

const themeOverrides = createTheme({
  components: {
    ...MuiCssBaselineStyles,
    ...MuiOutlinedInputStyles,
    ...MuiMenuItemStyles,
    ...MuiTooltipStyles,

    MuiTableCell: {
      styleOverrides: {
        root: {
          border: 'none',
        },
      },
    },
  },
});

const mergedTheme = deepmerge(themeOverrides, wbTheme);

export const theme = createTheme(mergedTheme, {
  components: {
    MuiAutocomplete: {
      styleOverrides: {
        input: {
          // iOS Safari zooms the viewport on focus when font-size < 16px.
          // Scoped to touch devices so desktop preserves the designed font size.
          '@media (hover: none) and (pointer: coarse)': {
            fontSize: 16,
          },
        },
      },
    },
  },
});
